export default "__VITE_ASSET__CCRvgVpS__"